/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {FishTypePost} from '../bioplanModels';
// @ts-ignore
import type {FishTypePut} from '../bioplanModels';
// @ts-ignore
import type {FishTypeResponse} from '../bioplanModels';
/**
 * PlanningFishTypeApi - axios parameter creator
 * @export
 */
export const PlanningFishTypeApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete fish type by its identifier
     * @param {string} fishTypeId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishTypesFishTypeIdDelete: async (
      fishTypeId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fishTypeId' is not null or undefined
      assertParamExists('fishTypesFishTypeIdDelete', 'fishTypeId', fishTypeId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('fishTypesFishTypeIdDelete', 'planId', planId);
      const localVarPath = `/fishTypes/{fishTypeId}`.replace(
        `{${'fishTypeId'}}`,
        encodeURIComponent(String(fishTypeId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get fish type by its identifier
     * @param {string} fishTypeId
     * @param {string} planId
     * @param {string} [cageId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishTypesFishTypeIdGet: async (
      fishTypeId: string,
      planId: string,
      cageId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fishTypeId' is not null or undefined
      assertParamExists('fishTypesFishTypeIdGet', 'fishTypeId', fishTypeId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('fishTypesFishTypeIdGet', 'planId', planId);
      const localVarPath = `/fishTypes/{fishTypeId}`.replace(
        `{${'fishTypeId'}}`,
        encodeURIComponent(String(fishTypeId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (cageId !== undefined) {
        localVarQueryParameter['cageId'] = cageId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update fish type for a plan
     * @param {string} fishTypeId
     * @param {FishTypePut} fishTypePut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishTypesFishTypeIdPut: async (
      fishTypeId: string,
      fishTypePut: FishTypePut,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fishTypeId' is not null or undefined
      assertParamExists('fishTypesFishTypeIdPut', 'fishTypeId', fishTypeId);
      // verify required parameter 'fishTypePut' is not null or undefined
      assertParamExists('fishTypesFishTypeIdPut', 'fishTypePut', fishTypePut);
      const localVarPath = `/fishTypes/{fishTypeId}`.replace(
        `{${'fishTypeId'}}`,
        encodeURIComponent(String(fishTypeId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(fishTypePut, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all fish types for a plan
     * @param {string} planId
     * @param {string} [cageId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishTypesGet: async (
      planId: string,
      cageId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('fishTypesGet', 'planId', planId);
      const localVarPath = `/fishTypes/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (cageId !== undefined) {
        localVarQueryParameter['cageId'] = cageId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create fish type for a plan
     * @param {FishTypePost} fishTypePost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishTypesPost: async (fishTypePost: FishTypePost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'fishTypePost' is not null or undefined
      assertParamExists('fishTypesPost', 'fishTypePost', fishTypePost);
      const localVarPath = `/fishTypes/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(fishTypePost, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningFishTypeApi - functional programming interface
 * @export
 */
export const PlanningFishTypeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningFishTypeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Delete fish type by its identifier
     * @param {string} fishTypeId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishTypesFishTypeIdDelete(
      fishTypeId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishTypesFishTypeIdDelete(fishTypeId, planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishTypeApi.fishTypesFishTypeIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get fish type by its identifier
     * @param {string} fishTypeId
     * @param {string} planId
     * @param {string} [cageId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishTypesFishTypeIdGet(
      fishTypeId: string,
      planId: string,
      cageId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FishTypeResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishTypesFishTypeIdGet(
        fishTypeId,
        planId,
        cageId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishTypeApi.fishTypesFishTypeIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update fish type for a plan
     * @param {string} fishTypeId
     * @param {FishTypePut} fishTypePut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishTypesFishTypeIdPut(
      fishTypeId: string,
      fishTypePut: FishTypePut,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FishTypeResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishTypesFishTypeIdPut(
        fishTypeId,
        fishTypePut,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishTypeApi.fishTypesFishTypeIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all fish types for a plan
     * @param {string} planId
     * @param {string} [cageId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishTypesGet(
      planId: string,
      cageId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FishTypeResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishTypesGet(planId, cageId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishTypeApi.fishTypesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create fish type for a plan
     * @param {FishTypePost} fishTypePost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishTypesPost(
      fishTypePost: FishTypePost,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FishTypeResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishTypesPost(fishTypePost, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishTypeApi.fishTypesPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningFishTypeApi - factory interface
 * @export
 */
export const PlanningFishTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningFishTypeApiFp(configuration);
  return {
    /**
     *
     * @summary Delete fish type by its identifier
     * @param {PlanningFishTypeApiFishTypesFishTypeIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishTypesFishTypeIdDelete(
      requestParameters: PlanningFishTypeApiFishTypesFishTypeIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .fishTypesFishTypeIdDelete(requestParameters.fishTypeId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get fish type by its identifier
     * @param {PlanningFishTypeApiFishTypesFishTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishTypesFishTypeIdGet(
      requestParameters: PlanningFishTypeApiFishTypesFishTypeIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FishTypeResponse> {
      return localVarFp
        .fishTypesFishTypeIdGet(
          requestParameters.fishTypeId,
          requestParameters.planId,
          requestParameters.cageId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update fish type for a plan
     * @param {PlanningFishTypeApiFishTypesFishTypeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishTypesFishTypeIdPut(
      requestParameters: PlanningFishTypeApiFishTypesFishTypeIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FishTypeResponse> {
      return localVarFp
        .fishTypesFishTypeIdPut(requestParameters.fishTypeId, requestParameters.fishTypePut, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all fish types for a plan
     * @param {PlanningFishTypeApiFishTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishTypesGet(
      requestParameters: PlanningFishTypeApiFishTypesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<FishTypeResponse>> {
      return localVarFp
        .fishTypesGet(requestParameters.planId, requestParameters.cageId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create fish type for a plan
     * @param {PlanningFishTypeApiFishTypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishTypesPost(
      requestParameters: PlanningFishTypeApiFishTypesPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FishTypeResponse> {
      return localVarFp
        .fishTypesPost(requestParameters.fishTypePost, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for fishTypesFishTypeIdDelete operation in PlanningFishTypeApi.
 * @export
 * @interface PlanningFishTypeApiFishTypesFishTypeIdDeleteRequest
 */
export interface PlanningFishTypeApiFishTypesFishTypeIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFishTypeApiFishTypesFishTypeIdDelete
   */
  readonly fishTypeId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningFishTypeApiFishTypesFishTypeIdDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for fishTypesFishTypeIdGet operation in PlanningFishTypeApi.
 * @export
 * @interface PlanningFishTypeApiFishTypesFishTypeIdGetRequest
 */
export interface PlanningFishTypeApiFishTypesFishTypeIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFishTypeApiFishTypesFishTypeIdGet
   */
  readonly fishTypeId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningFishTypeApiFishTypesFishTypeIdGet
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningFishTypeApiFishTypesFishTypeIdGet
   */
  readonly cageId?: string;
}

/**
 * Request parameters for fishTypesFishTypeIdPut operation in PlanningFishTypeApi.
 * @export
 * @interface PlanningFishTypeApiFishTypesFishTypeIdPutRequest
 */
export interface PlanningFishTypeApiFishTypesFishTypeIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFishTypeApiFishTypesFishTypeIdPut
   */
  readonly fishTypeId: string;

  /**
   *
   * @type {FishTypePut}
   * @memberof PlanningFishTypeApiFishTypesFishTypeIdPut
   */
  readonly fishTypePut: FishTypePut;
}

/**
 * Request parameters for fishTypesGet operation in PlanningFishTypeApi.
 * @export
 * @interface PlanningFishTypeApiFishTypesGetRequest
 */
export interface PlanningFishTypeApiFishTypesGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFishTypeApiFishTypesGet
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningFishTypeApiFishTypesGet
   */
  readonly cageId?: string;
}

/**
 * Request parameters for fishTypesPost operation in PlanningFishTypeApi.
 * @export
 * @interface PlanningFishTypeApiFishTypesPostRequest
 */
export interface PlanningFishTypeApiFishTypesPostRequest {
  /**
   *
   * @type {FishTypePost}
   * @memberof PlanningFishTypeApiFishTypesPost
   */
  readonly fishTypePost: FishTypePost;
}

/**
 * PlanningFishTypeApi - object-oriented interface
 * @export
 * @class PlanningFishTypeApi
 * @extends {BaseAPI}
 */
export class PlanningFishTypeApi extends BaseAPI {
  /**
   *
   * @summary Delete fish type by its identifier
   * @param {PlanningFishTypeApiFishTypesFishTypeIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishTypeApi
   */
  public fishTypesFishTypeIdDelete(
    requestParameters: PlanningFishTypeApiFishTypesFishTypeIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFishTypeApiFp(this.configuration)
      .fishTypesFishTypeIdDelete(requestParameters.fishTypeId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get fish type by its identifier
   * @param {PlanningFishTypeApiFishTypesFishTypeIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishTypeApi
   */
  public fishTypesFishTypeIdGet(
    requestParameters: PlanningFishTypeApiFishTypesFishTypeIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFishTypeApiFp(this.configuration)
      .fishTypesFishTypeIdGet(requestParameters.fishTypeId, requestParameters.planId, requestParameters.cageId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update fish type for a plan
   * @param {PlanningFishTypeApiFishTypesFishTypeIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishTypeApi
   */
  public fishTypesFishTypeIdPut(
    requestParameters: PlanningFishTypeApiFishTypesFishTypeIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFishTypeApiFp(this.configuration)
      .fishTypesFishTypeIdPut(requestParameters.fishTypeId, requestParameters.fishTypePut, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all fish types for a plan
   * @param {PlanningFishTypeApiFishTypesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishTypeApi
   */
  public fishTypesGet(requestParameters: PlanningFishTypeApiFishTypesGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningFishTypeApiFp(this.configuration)
      .fishTypesGet(requestParameters.planId, requestParameters.cageId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create fish type for a plan
   * @param {PlanningFishTypeApiFishTypesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishTypeApi
   */
  public fishTypesPost(requestParameters: PlanningFishTypeApiFishTypesPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningFishTypeApiFp(this.configuration)
      .fishTypesPost(requestParameters.fishTypePost, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
